import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { PROJECT_PRIORITY_FILTER_OPTIONS, type ProjectPriorityFilterValue } from '@/lib/project-priority'

const LABELS: Record<ProjectPriorityFilterValue, string> = {
  all: 'Any project priority',
  high: 'High priority projects',
  standard: 'Standard priority projects',
  low: 'Low priority projects',
}

/** Filter a list by its projects' priority (USA-1451), beside the page's other filters. */
export function ProjectPriorityFilter({
  value,
  onValueChange,
}: {
  value: ProjectPriorityFilterValue
  onValueChange: (value: ProjectPriorityFilterValue) => void
}) {
  return (
    <Select value={value} onValueChange={(next) => onValueChange(next as ProjectPriorityFilterValue)}>
      <SelectTrigger aria-label="Project priority filter" className="w-full md:w-[210px]">
        <SelectValue placeholder="Priority" />
      </SelectTrigger>
      <SelectContent>
        {PROJECT_PRIORITY_FILTER_OPTIONS.map((option) => (
          <SelectItem key={option} value={option}>
            {LABELS[option]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
